var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "L4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    enableBackground: "new 0 0 0 0",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    stroke: "none",
    cx: 6,
    cy: 50,
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: 0.1
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    stroke: "none",
    cx: 26,
    cy: 50,
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: 0.2
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    stroke: "none",
    cx: 46,
    cy: 50,
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/ChatBubble.a552f3bccb60ef33ddf41e51ee668684.svg";
export { ForwardRef as ReactComponent };